import * as Sentry from '@sentry/react';
import { toast } from 'sonner';

async function request(url: string, options: RequestInit = {}) {
  console.log('[options]', JSON.stringify(options, null, 2));

  // 發送api
  Sentry.withScope(function (scope) {
    const id = window.location.href.split('/').pop();
    scope.setLevel('info');
    scope.setTag('id', id);
    Sentry.captureMessage(`${id} Sending`);
  });

  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      console.log('error :>> ', JSON.stringify(error, null, 2));

      // api回400
      Sentry.withScope(function (scope) {
        const id = window.location.href.split('/').pop();
        scope.setLevel('warning');
        scope.setTag('id', id);
        Sentry.captureMessage(`${id} Failed`);
      });
      throw new Error(error.message || `HTTP error: ${response.status}`);
    }

    // api回200
    const data = await response.json();

    Sentry.withScope(function (scope) {
      console.log('response :>> ', JSON.stringify(data, null, 2));

      const id = window.location.href.split('/').pop();
      scope.setLevel('info');
      scope.setTag('id', id);
      Sentry.captureMessage(`${id} Success`);
    });

    return data;
  } catch (error: any) {
    if (error?.message !== 'Failed to fetch') {
      toast.error((error as Error)?.message);
    }
    throw error;
  }
}

export default request;
